import { render, staticRenderFns } from "./ModalContentExpense.vue?vue&type=template&id=72f118fd&scoped=true&"
import script from "./ModalContentExpense.vue?vue&type=script&lang=js&"
export * from "./ModalContentExpense.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentExpense.vue?vue&type=style&index=0&id=72f118fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f118fd",
  null
  
)

export default component.exports